import * as React from 'react';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation, Footer } from './components';
import { MainPage } from 'pages/main-page';
import EBookPage from './pages/ebook/ebook';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EbookPopup } from './components/ebook-popup/ebook-popup';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

const BYPASS_KEY = 'ap_preview_access';
const BYPASS_PARAM = 'show';
const BYPASS_VALUE = 'admin';

function MaintenancePage() {
        return (
                <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-primary-50 flex flex-col items-center justify-center px-6 text-center">
                        <div className="absolute inset-0 overflow-hidden pointer-events-none">
                                <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-primary-100/50 rounded-full blur-3xl" />
                                <div className="absolute bottom-0 left-0 w-80 h-80 bg-accent-100/30 rounded-full blur-3xl" />
                        </div>

                        <div className="relative z-10 max-w-lg">
                                <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-soft-lg">
                                        <FitnessCenterIcon sx={{ fontSize: 40, color: 'white' }} />
                                </div>

                                <div className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-6 tracking-widest uppercase font-montserrat-custom-medium">
                                        Amelia Pałczyńska — Trenerka personalna kobiet
                                </div>

                                <h1 className="font-playfair-custom-bold text-4xl lg:text-5xl text-gray-900 mb-5 leading-tight overflow-visible">
                                        Trwają prace
                                        <span className="block text-gradient pb-3">modernizacyjne</span>
                                </h1>

                                <p className="text-gray-500 font-montserrat-custom-medium text-lg leading-relaxed mb-8">
                                        Pracujemy nad nową odsłoną strony. Wrócimy wkrótce!
                                </p>

                                <div className="flex items-center justify-center gap-2">
                                        <span className="w-2.5 h-2.5 bg-primary-400 rounded-full animate-float" style={{ animationDelay: '0s' }} />
                                        <span className="w-2.5 h-2.5 bg-primary-300 rounded-full animate-float" style={{ animationDelay: '0.25s' }} />
                                        <span className="w-2.5 h-2.5 bg-primary-200 rounded-full animate-float" style={{ animationDelay: '0.5s' }} />
                                </div>
                        </div>
                </div>
        );
}

export default function Root() {
        const { pathname, search } = useLocation();
        const [hasAccess, setHasAccess] = useState<boolean>(() => {
                return sessionStorage.getItem(BYPASS_KEY) === 'true';
        });

        useEffect(() => {
                const params = new URLSearchParams(search);
                if (params.get(BYPASS_PARAM) === BYPASS_VALUE) {
                        sessionStorage.setItem(BYPASS_KEY, 'true');
                        setHasAccess(true);
                }
        }, [search]);

        useEffect(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
        }, [pathname]);

        if (!hasAccess) {
                return <MaintenancePage />;
        }

        const renderContent = () => {
                if (pathname === "/ebook") {
                        return <EBookPage />;
                }
                return (
                        <>
                                <Navigation />
                                <main className="flex-grow">
                                        {pathname === '/' ? <MainPage /> : <Outlet />}
                                </main>
                                <Footer />
                                <EbookPopup />
                        </>
                );
        };

        return (
                <div className="flex flex-col min-h-screen">
                        {renderContent()}
                        <ToastContainer
                                position="top-center"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                style={{ zIndex: 9999 }}
                        />
                </div>
        );
}
